<template>
    <div>
        <div class="dataBox">
            <div v-for="(p, id) in persents" :key="'p'+id">
                <el-progress v-if="p.percent > 0" class="percent"
                    :percentage="p.percent"
                    :show-text="false"
                    :stroke-width="height"
                    :color="getColor(id)"></el-progress>
            </div>
            <div style="position:relative;">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    props: {
        // 进度条高度
        height: {
            type: Number,
            default: 52
        },
        // 所有进度条的进度
        persents: {
            type: Array,
            required: true,
            default: ()=>{
                return []
            }
        },
        insId: {
          type: [Number, String]
        }
    },
    // watch:{
    //     persents: {
    //         handler (newVal, oldVal) {
    //             // this.$emit('update:networkItem', newVal)
    //         },
    //         deep: true //是否深度监听
    //     }
    // },
    computed: {
      ...mapState(['socketInfo'])
    },
    data: vm=>({
      // 进度条颜色，默认四种，可以指定传入
      colors: ['#cbf1b7','#b9ea9f','#b3ef93','#99f16b']
    }),
    methods: {
        // 随机颜色
        randomRgb(){
            const R = Math.floor(Math.random() * 155);
            const G = Math.floor(Math.random() * 255);
            const B = Math.floor(Math.random() * 155);
            return 'rgb(' + R + ',' + G + ',' + B + ')'
        },
        // 获取颜色
        getColor(id){
          if(this.socketInfo && this.insId != this.socketInfo.insId){
            return this.colors[this.persents.length - 1]
          }
          if(id < this.colors.length){
                return this.colors[id]
          }else{
            const color = this.randomRgb()
            this.colors.push(color)
            return color
          }
        }
    }
}
</script>
<style scoped>
.container{
    padding: 20px;
}
.dataBox{
    /* border-bottom: 1px solid #EBEEF5; */
    position: relative;
    /* height: 64px; */
}
.dataBox >>> .el-progress-bar__outer{
    /* height: 4px !important; */
    background-color: #fff;
    border-radius: 0;
}
.dataBox >>> .el-progress-bar__inner{
    border-radius: 0;
}

.percent{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    opacity: 0.5;
}
</style>
